import React, { useState, useEffect } from 'react';
import BulletinCard from '../Components/BulletinCard';
import bulletinService from '../services/bulletinService';

// Server-driven user bulletins

const UserBulletinBoard = () => {
  const [bulletins, setBulletins] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    hasNext: false,
    hasPrev: false,
  });
  const itemsPerPage = 10;
  const [loading, setLoading] = useState(true);

  const loadBulletins = async (page = 1) => {
    try {
      setLoading(true);
      const result = await bulletinService.getUserBulletins(page, itemsPerPage);
      setBulletins(result.bulletins || []);
      setPagination(result.pagination || {
        currentPage: page,
        totalPages: 1,
        totalRecords: 0,
        hasNext: false,
        hasPrev: false,
      });
    } catch (e) {
      console.error('Failed to load user bulletins', e);
      setBulletins([]);
      setPagination({
        currentPage: 1,
        totalPages: 1,
        totalRecords: 0,
        hasNext: false,
        hasPrev: false,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadBulletins(1);
  }, []);

  const currentBulletins = bulletins; // Server returns already paginated

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-4 md:py-8 w-full max-w-9xl mx-auto">
      {/* <div className="sm:flex sm:justify-between sm:items-center mb-8">
        <h1 className="text-2xl md:text-3xl text-white font-bold">Bulletin Board</h1>
      </div> */}

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white"></div>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
            {currentBulletins.map((bulletin) => (
              <BulletinCard key={bulletin.id} bulletin={bulletin} />
            ))}
          </div>

          {/* Pagination Controls */}
          {pagination.totalPages > 1 && (
            <div className="flex items-center justify-center mt-8 md:mt-12">
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => loadBulletins(pagination.currentPage - 1)}
                  disabled={!pagination.hasPrev}
                  className={`px-3 py-1.5 md:px-4 md:py-2 text-sm md:text-base rounded-lg border transition-all duration-200 ${
                    !pagination.hasPrev
                      ? 'border-gray-600 text-gray-500 cursor-not-allowed'
                      : 'border-blue-500 text-blue-400 hover:bg-blue-500 hover:text-white'
                  }`}
                >
                  Previous
                </button>

                <div className="flex space-x-1 overflow-x-auto max-w-[200px] sm:max-w-none scrollbar-hide">
                  {Array.from({ length: pagination.totalPages }, (_, i) => i + 1).map((number) => (
                    <button
                      key={number}
                      onClick={() => loadBulletins(number)}
                      className={`px-2.5 py-1.5 md:px-3 md:py-2 text-sm md:text-base rounded-lg transition-all duration-200 whitespace-nowrap ${
                        pagination.currentPage === number
                          ? 'bg-blue-600 text-white shadow-lg'
                          : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                      }`}
                    >
                      {number}
                    </button>
                  ))}
                </div>

                <button
                  onClick={() => loadBulletins(pagination.currentPage + 1)}
                  disabled={!pagination.hasNext}
                  className={`px-3 py-1.5 md:px-4 md:py-2 text-sm md:text-base rounded-lg border transition-all duration-200 ${
                    !pagination.hasNext
                      ? 'border-gray-600 text-gray-500 cursor-not-allowed'
                      : 'border-blue-500 text-blue-400 hover:bg-blue-500 hover:text-white'
                  }`}
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </>
      )}

      {/* End of content */}
    </div>
  );
};

export default UserBulletinBoard;